export default [{
  path: '/notice',
  children: [{
    path: 'confirm',
    name: 'confirm',
    meta: {
      title: '云南考试网'
    },
    component: () => import('@/views/notice/confirm.vue')
  }, {
    path: 'results',
    name: 'results',
    meta: {
      title: '云南考试网'
    },
    component: () => import('@/views/notice/results.vue')
  }]
}]